var addMonths = require('../add_months/index.js')

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, amount) {
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters



//////////////////
// WEBPACK FOOTER
// ./~/date-fns/add_quarters/index.js
// module id = 453
// module chunks = 7